// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
import keyMirror from 'mattermost-redux/utils/key_mirror';

export default keyMirror({
    RECEIVED_CLOUD_CUSTOMER: null,
    RECEIVED_CLOUD_PRODUCTS: null,
    RECEIVED_CLOUD_SUBSCRIPTION: null,
    RECEIVED_CLOUD_INVOICES: null,
    RECEIVED_CLOUD_SUBSCRIPTION_STATS: null,
});
